import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Landing from "../components/Landing";
import About from "../components/About";
import WhatWeBring from "../components/WhatWeBring";
import Services from "../components/Services";
import CallToAction from "../components/CallToAction";

function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace("#", "");
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);

  return (
    <>
      <Landing />
      <About />
      <WhatWeBring />
      <Services />
      <CallToAction />
    </>
  );
}

export default Home;
